import { useRef, useEffect } from 'react';
import TextInformation from '../../../../../../components/TextInformation/TextInformation';
import {
  SmallHeightDivider,
  BodyTextBold,
  BodyText,
} from '../../../../../../theme/Styles';
import { Container } from '../../../../styles/ServiceRequestedDetailsStyles';
import { Grid } from '@mui/material';
import DocumentsOfRequestsCard from '../../../../../../components/DocumentsOfRequestsCard/DocumentsOfRequestsCard';
import { useQuery, useQueryClient } from 'react-query';
import { format } from 'date-fns';
import { replaceGuionToSlashFromString } from '../../../../../../utilities/functions/StringUtil';
import { useTranslation } from 'react-i18next';
import CenterLoading from '../../../../../../components/CenterLoading/CenterLoading';
import { getDocumentsFromRequest } from '../../../../../../api/ServiceRequestedDetails';
import { cacheConfig } from '../../../../../../cacheConfig';

function Details(props) {
  const queryClient = useQueryClient();
  const documentsRef = useRef(null);

  const requestSubServiceID = props.data.request_id;

  const userData = queryClient.getQueryData(['userData']);
  const requestData = queryClient.getQueryData(['subServiceRequestedDetail', requestSubServiceID]);

  const { data: documentsDataForSubRequest, isLoading: documentsDataForSubServiceIsLoading } =
    useQuery(['documentsDataForSubRequest', requestSubServiceID], () =>
      getDocumentsFromRequest(requestSubServiceID, userData?.payload?.citizen_id), {
      staleTime: cacheConfig.staleTimeForRequestDocuments
    });

  const [t] = useTranslation('desk');

  const documentsData = documentsDataForSubRequest?.request_document?.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  }).map((documentPersonal) => {
    if (documentPersonal.origin_doc === 0) {
      return documentPersonal;
    }
  }).map((document) => {
    if (typeof document === "object")
      return {
        name: `${document.name}.${document.extension}`,
        //pending to change
        documentType: document.extension,
        date: format(new Date(replaceGuionToSlashFromString(document.created_at)), 'yyyy-MM-dd HH:mm:ss'),
        url: document.url,
        type: document.extension
      }
  }).filter((filteredDocument) => {
    return typeof filteredDocument === "object"
  })

  const documentsInstitutionData = documentsDataForSubRequest?.request_document?.sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  }).map((documentInstitutional) => {
    if (documentInstitutional.origin_doc === 1) {
      return documentInstitutional;
    }
  }).map((document) => {
    if (typeof document === "object")
      return {
        name: `${document.name}.${document.extension}`,
        //pending to change
        documentType: document.extension,
        date: format(new Date(replaceGuionToSlashFromString(document.created_at)), 'yyyy-MM-dd HH:mm:ss'),
        url: document.url,
        type: document.extension
      }
  }).filter((filteredDocument) => {
    return typeof filteredDocument === "object"
  })

  useEffect(() => {
    if (window.location.hash === "#documents") {
      //When documents action required its send scroll to documents and remove hash
      documentsRef?.current?.scrollIntoView();
    }
  }, [window.location.hash]);

  if (requestData === undefined || documentsDataForSubServiceIsLoading) return <CenterLoading />
  return (
    <Container>
      <TextInformation title='Detalles de Solicitud' />
      <SmallHeightDivider />
      <SmallHeightDivider />
      <Grid
        alignItems='center'
        justifyContent='flex-start'
        container
        direction='row'
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 6, sm: 8, md: 12 }}
      >
        <Grid item xs={6} sm={4} md={4}>
          <BodyTextBold>
            Numero de solicitud:
          </BodyTextBold>
          <BodyText>
            {requestData?.request?.code}
          </BodyText>
        </Grid>

        <Grid item xs={6} sm={4} md={4}>
          <BodyTextBold>Estatus:</BodyTextBold>
          <BodyText>{requestData?.request?.status?.name}</BodyText>
        </Grid>
        <Grid item xs={6} sm={4} md={4}>
          <BodyTextBold>{t('Date')}:</BodyTextBold>
          <BodyText>
            {new Date(
              replaceGuionToSlashFromString(requestData?.request?.created_at)
            ).toLocaleDateString()}
          </BodyText>
        </Grid>

        {requestData?.data?.map((item) => (
          <Grid item xs={6} sm={4} md={4}>
            <BodyTextBold>{item.label}</BodyTextBold>
            <BodyText>
              {item.type === 'text'
                ? item.value
                : item.type === 'checkbox'
                  ? 'Si'
                  : item.labelValue}
            </BodyText>
          </Grid>
        ))}
      </Grid>

      <SmallHeightDivider />
      <SmallHeightDivider />
      {

        documentsInstitutionData?.length > 0 &&
        <div>
          <TextInformation title="Documentos emitidos por institución" />
          <SmallHeightDivider />
          <DocumentsOfRequestsCard data={documentsInstitutionData} />
        </div>
      }

      <SmallHeightDivider />
      <SmallHeightDivider />
      {
        documentsData?.length > 0 &&
        <div ref={documentsRef} name="documents" >
          <TextInformation title="Documentos subidos" />
          <SmallHeightDivider />
          <DocumentsOfRequestsCard data={documentsData} />
        </div>
      }
    </Container>
  );
}

export default Details;
